<template>
  <div class="settings">
    <RouterView />
  </div>
</template>

<script>
export default {
  name: 'Settings',
};
</script>

<style scoped>
.settings {
  padding: 1rem;
}
</style>
